import PropTypes from 'prop-types';
import React, { forwardRef, useRef } from 'react';

import { getAwardsBgColor } from '$utilities/data';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const AwardsModuleBannerText = forwardRef(({
    backgroundColor,
    body,
    title,
}, ref) => {

    const bg = getAwardsBgColor(backgroundColor);

    return (
        <section
            className='text-black -translate-x-1/2 left-1/2 w-full mt-80 overflow-hidden relative md:h-[414px] pt-90 pb-90 py-25 md:pt-140 md:pb-125 justify-center'
            ref={ref}
            style={{ backgroundColor: bg }}>
            <div className='layout-container'>
                <div className='px-10 sm:px-20 gap-30 flex flex-col'>
                    <h2 className='type-style-awards-subheading-uppercase md:absolute top-100'>
                        {title}
                    </h2>

                    <p className='type-style-awards-body-extended'>
                        {body}
                    </p>
                </div>
            </div>
        </section>
    );
});

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

AwardsModuleBannerText.displayName = 'AwardsModuleBannerText';

const propTypes = {
    backgroundColor: PropTypes.string,
    body: PropTypes.string,
    title: PropTypes.string,
};

AwardsModuleBannerText.propTypes = propTypes;

export default AwardsModuleBannerText;
